export const actionTypes = {
  ADD_TICKET_SUCCESS: 'PEAK_CONTACTS/ADD_TICKET_SUCCESS',
  ADD_TICKET_LOADING: 'PEAK_CONTACTS/ADD_TICKET_LOADING',
};
